import { forwardRef, memo } from 'react';
import map from 'lodash/map';
import split from 'lodash/split';
import trim from 'lodash/trim';
import size from 'lodash/size';
import replace from 'lodash/replace';
import { FormattedMessage } from 'react-intl';
// Material UI imports
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
// local imports
import BoxTypography from '../mixins/BoxTypography';
// SCSS imports
import { list, item } from './LevelDescription.module.scss';

type LevelDescriptionProps = {
  readonly description?: string;
  readonly level?: number | null;
  readonly flat?: boolean;
}

const LevelDescription = forwardRef<HTMLSpanElement, LevelDescriptionProps>(({
  description = '',
  level,
  flat = false
}, ref) => (
  <>
    <Typography ref={ref} paragraph variant={level ? 'h5' : undefined}>
      {level
        ? <FormattedMessage id="common.skill_level.title" values={{ level, inferred: null }}/>
        : <FormattedMessage id="skill.level_description_info"/>}
    </Typography>
    {flat ? (
      <Box component="div" pb={2}>
        {map(split(description, '\n'), (line, index) => {
          const text = trim(line);
          return size(text) >= 1 && (
            <BoxTypography key={index} variant="body1" pb={1}>
              {text}
            </BoxTypography>
          );
        })}
      </Box>
    ) : (
      <ul className={list}>
        {map(split(description, '\n'), (line, index) => {
          const text = replace(trim(line), /^\s*[-–—]+\s*/u, '');
          return size(text) >= 1 && (
            <Typography key={index} variant="body1" component="li" className={item}>
              {text}
            </Typography>
          );
        })}
      </ul>
    )}
  </>
));

LevelDescription.displayName = 'LevelDescription';

export default memo(LevelDescription);
